/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type GetAllGooseGameQuestsQueryVariables = Types.Exact<{
  eventId: Types.Scalars["Float"];
}>;

export type GetAllGooseGameQuestsQuery = {
  gooseGameQuests: Array<
    Pick<
      Types.GooseGameQuest,
      | "id"
      | "title"
      | "type"
      | "points_rewarded"
      | "completion_limit"
      | "question_string"
      | "question_answer"
      | "description"
      | "quest_event_activity_category"
      | "flash"
      | "hidden"
      | "meta"
    >
  >;
};

export const GetAllGooseGameQuestsDocument = gql`
  query GetAllGooseGameQuests($eventId: Float!) {
    gooseGameQuests(event_id: $eventId) {
      id
      title
      type
      points_rewarded
      completion_limit
      question_string
      question_answer
      description
      quest_event_activity_category
      flash
      hidden
      meta
    }
  }
`;

/**
 * __useGetAllGooseGameQuestsQuery__
 *
 * To run a query within a React component, call `useGetAllGooseGameQuestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllGooseGameQuestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllGooseGameQuestsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetAllGooseGameQuestsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAllGooseGameQuestsQuery,
    GetAllGooseGameQuestsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetAllGooseGameQuestsQuery,
    GetAllGooseGameQuestsQueryVariables
  >(GetAllGooseGameQuestsDocument, baseOptions);
}
export function useGetAllGooseGameQuestsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllGooseGameQuestsQuery,
    GetAllGooseGameQuestsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetAllGooseGameQuestsQuery,
    GetAllGooseGameQuestsQueryVariables
  >(GetAllGooseGameQuestsDocument, baseOptions);
}
export type GetAllGooseGameQuestsQueryHookResult = ReturnType<
  typeof useGetAllGooseGameQuestsQuery
>;
export type GetAllGooseGameQuestsLazyQueryHookResult = ReturnType<
  typeof useGetAllGooseGameQuestsLazyQuery
>;
export type GetAllGooseGameQuestsQueryResult = ApolloReactCommon.QueryResult<
  GetAllGooseGameQuestsQuery,
  GetAllGooseGameQuestsQueryVariables
>;
